<!--
 * @Description  : 
 * @Author       : BigBigger
 * @Date         : 2022-07-12 16:28:37
 * @LastEditTime : 2025-08-14 11:44:07
 * @LastEditors  : BigBigger
-->
<template>
  <div class="through-pay" v-if="detail.applyWaySwitch === 2 && btnStateComputed.canClick && btnStateComputed.type === 0">
    <div class="through-pay-title">请选择报名方案（2选1）：</div>

    <div class="through-pay-select" v-for="item in applyWays"  :class="{'active': value === item.nameVal}" @click="change(item.nameVal)">{{item.name}}</div>
  </div>
</template>

<script>
import { getApplyWay } from '@/api/api';

export default {
  name: "ApplyWay",
  model: {
    props: 'value',
    event: 'change',
  },
  props: {
    value: {type: Number},
    detail: {
      type: Object,
      default: () => {
        return {}
      }
    },
    btnStateComputed: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return { applyWays: [] }
  },
  mounted() {
    getApplyWay().then(res => {
      this.applyWays = res.data
      if (this.detail.applyWaySwitch === 2) this.change(this.applyWays[0]?.nameVal)
    })
  },
  methods: {
    change(val) {
      this.$emit('change', val)
    }
  },
}
</script>

<style scoped lang="less">
  .through-pay {
    background: #fff;
    font-size: 14px;
    padding: 0.2rem 0.4rem;
    color: #333;
    margin-top: 0.2rem;
    &-select {
      font-size: 14px;
      height: 35px;
      line-height: 35px;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 10px 0 20px;
      background: #F2F2F2;
      margin: 10px 0;
      border: 1px solid transparent;
      position: relative;
      &.active {
        color: #FF3F47;
        background: #FDEFEF;
        border-color: #FF7773;
      }
    }
    &-tip {
      color: #FF3F47;
    }
    .price {
      color: #FF3F47;
      height: 40px;
      line-height: 40px;
      display: flex;
      padding: 10px 0;
      font-size: 20px;
      color: #FF3F47;
      font-weight: bold;
    }
  }
</style>